// Translations for ADAPEL website
export const translations = {
  fr: {
    // Navigation
    nav: {
      approche: "Approche",
      expertises: "Expertises",
      missions: "Missions",
      casClient: "Cas d'usage",
      cta: "Parlons de vos projets"
    },

    // Hero
    hero: {
      badge: "Processus • Données • Systèmes • Exécution",
      title1: "Structurer vos",
      titleHighlight1: "transformations",
      title2: "Accélérer vos",
      titleHighlight2: "résultats",
      subtitle: "Les organisations évoluent, les processus se complexifient et les systèmes se multiplient.\n\nLorsque les processus, les systèmes et les équipes ne sont plus parfaitement alignés, les décisions ralentissent et l'exécution devient plus difficile.\n\nADAPEL apporte la structure, le pilotage et les éléments factuels nécessaires pour retrouver de la visibilité, sécuriser l'exécution et accélérer la création de valeur.",
      cta1: "Parlons de vos projets",
      cta2: "Voir des exemples",
      badges: [
        "Transformation des opérations",
        "Process Mining & Process Intelligence",
        "ERP Transformation",
        "Data & Dashboards",
        "PMO & Delivery Excellence"
      ]
    },

    // Positioning
    positioning: {
      label: "Positionnement & Approche",
      title: "Des transformations",
      titleHighlight: "structurées",
      subtitle: "Pragmatiques, factuelles et ancrées dans l'exécution.",
      positionTitle: "Positionnement",
      positionText: "ADAPEL accompagne les organisations confrontées à des transformations transverses, des projets complexes ou des enjeux de performance nécessitant davantage de structure, de visibilité et de capacité d'exécution.\n\nNous intervenons à l'intersection des processus, des organisations, des données, des systèmes et des modes de pilotage.\n\nNotre rôle consiste à apporter la structure et les éléments factuels nécessaires pour faciliter les décisions, sécuriser les trajectoires et accélérer l'exécution.\n\nEn France comme à l'international, nous accompagnons des organisations évoluant dans des environnements exigeants, multi-acteurs et à forts enjeux."
    },

    // Approach
    approach: {
      title: "Approche",
      subtitle: "Structurée, pragmatique, factuelle et orientée résultats.",
      steps: [
        "Comprendre la réalité opérationnelle et les processus tels qu'ils sont réellement exécutés",
        "Objectiver les constats grâce aux données, aux faits et aux équipes terrain",
        "Faire converger les enjeux et les points de vue des différentes parties prenantes",
        "Co-construire avec les équipes les processus cibles, les organisations et les trajectoires de transformation",
        "Définir des priorités claires, une feuille de route réaliste et des modes de pilotage adaptés",
        "Sécuriser l'exécution grâce à une gouvernance claire et des responsabilités partagées",
        "Accompagner les équipes dans la durée afin d'ancrer durablement les changements"
      ]
    },

    // Stats
    stats: [
      { value: "10+", label: "années d'expérience" },
      { value: "+15", label: "projets transformation" }
    ],

    // Expertises
    expertises: {
      label: "Expertises",
      title: "Des expertises",
      titleHighlight: "complémentaires",
      subtitle: "Processus, données, systèmes et pilotage : des leviers complémentaires au service de l'exécution.",
      cards: [
        {
          title: "Transformation des opérations",
          subtitle: "Lean, Excellence Opérationnelle, amélioration continue",
          items: [
            "Diagnostics et optimisation des flux",
            "Démarches Lean, Kaizen et DMAIC",
            "Standardisation et ancrage des bonnes pratiques"
          ]
        },
        {
          title: "Process Mining & Process Intelligence",
          subtitle: "SAP Signavio, analyse des flux réels",
          items: [
            "Process Mining et compréhension des flux réels",
            "Cartographie, standardisation et simplification des processus",
            "Identification des écarts et des opportunités d'amélioration"
          ]
        },
        {
          title: "ERP Transformation",
          subtitle: "SAP ECC, S/4HANA, IFS",
          items: [
            "Cadrage et déploiement ERP",
            "Traduction des besoins métiers en solutions opérationnelles",
            "Accompagnement des équipes et conduite du changement"
          ]
        },
        {
          title: "Data, Performance & Executive Dashboards",
          subtitle: "Power BI, KPIs, tableaux de bord direction",
          items: [
            "Définition et mise en place de KPIs opérationnels",
            "Tableaux de bord et reporting direction",
            "Aide au pilotage et à la prise de décision"
          ]
        },
        {
          title: "PMO & Delivery Excellence",
          subtitle: "Gouvernance, pilotage, transformations complexes",
          items: [
            "Gouvernance et pilotage de programmes",
            "Obeya et management visuel",
            "Coordination multi-acteurs et aide aux arbitrages"
          ]
        }
      ]
    },

    // Case Study - Cas d'usage
    caseStudy: {
      label: "Cas d'usage",
      title: "Transformer les processus",
      titleHighlight: "avant de transformer les systèmes",
      subtitle: "Comment un programme de transformation métier et Process Mining a permis d'objectiver les priorités, d'améliorer la performance opérationnelle et de préparer le terrain pour S/4HANA.",
      tags: ["Transformation Business", "Process Mining", "Change Management", "Industrie - International"],
      contexte: {
        title: "Contexte",
        text: "Un groupe industriel international, acteur majeur de son secteur depuis plus de 70 ans, fait face à une croissance soutenue nécessitant une structuration accrue de ses processus métier. En préparation de sa migration vers SAP S/4HANA (horizon 2028), la Direction Générale lance un programme stratégique d'optimisation : le PEA (Process Efficiency Accelerator)."
      },
      role: {
        title: "Notre rôle",
        items: [
          {
            title: "Program Manager",
            description: "Co-pilotage du programme de transformation en partenariat avec la direction de programme IT."
          },
          {
            title: "Business Process Owner",
            description: "Responsabilité des processus end-to-end P2P, O2C, Manufacturing et Supply Chain : analyse des flux réels, identification et priorisation des irritants, définition des processus cibles et accompagnement des équipes dans l'exécution des actions et le suivi des résultats."
          }
        ]
      },
      objectives: {
        title: "Enjeux & Objectifs",
        items: [
          "Obtenir une vision factuelle des processus réellement exécutés",
          "Identifier et prioriser les leviers de performance les plus pertinents",
          "Générer des gains visibles rapidement tout en structurant les transformations de plus long terme",
          "Harmoniser et standardiser les processus à l'échelle du groupe",
          "Renforcer l'appropriation des processus par les équipes métiers",
          "Préparer le terrain pour la future transformation S/4HANA"
        ]
      },
      methodology: {
        title: "Démarche",
        steps: ["Comprendre", "Objectiver", "Prioriser", "Exécuter", "Pérenniser"]
      },
      results: {
        title: "Résultats & Impacts",
        items: [
          { value: "138", label: "insights qualifiés" },
          { value: "+40", label: "key users mobilisés" },
          { value: "+7", label: "pays" },
          { value: "+20", label: "initiatives lancées" }
        ],
        impacts: [
          "MRP & pilotage opérationnel : Fiabilisation des données, harmonisation des pratiques et généralisation du monitoring des usages, permettant de transformer le MRP en véritable outil de pilotage opérationnel.",
          "ATP & performance fournisseurs : Amélioration de la qualité des données d'approvisionnement et mise sous pilotage de la performance fournisseurs via des indicateurs factuels et des mécanismes de gouvernance adaptés."
        ]
      }
    },

    // Achievements (Réalisations)
    achievements: {
      label: "Missions",
      title: "Exemples de",
      titleHighlight: "missions",
      subtitle: "Quelques exemples de missions réalisées, dans le respect de la confidentialité client.",
      challengeLabel: "Enjeu",
      interventionLabel: "Intervention",
      impactLabel: "Impact",
      items: [
        {
          sector: "Construction",
          country: "France",
          title: "Supporter le lancement d'une démarche d'Excellence Opérationnelle",
          challenge: "Construire une démarche cohérente et durable à l'échelle de l'organisation.",
          intervention: "Définition de la feuille de route, des standards, des formations et des premiers chantiers pilotes.",
          impact: "Lancement opérationnel de la démarche et montée en compétence progressive des équipes."
        },
        {
          sector: "Nucléaire",
          country: "Finlande",
          title: "Structurer le pilotage d'un programme complexe",
          challenge: "Améliorer la visibilité et la coordination entre les niveaux opérationnels et la direction du programme.",
          intervention: "Mise en place de 9 Obeyas, nouveaux rituels de pilotage et coaching des animateurs.",
          impact: "Boucles de décision plus courtes et équipes progressivement autonomes."
        },
        {
          sector: "Machines Agricoles",
          country: "International",
          title: "Piloter un portefeuille projets Engineering complexe",
          challenge: "Améliorer la visibilité, la priorisation et le pilotage d'un portefeuille de projets d'ingénierie dans un environnement multi-projets et fortement interconnecté.",
          intervention: "Animation des instances de gouvernance, suivi du portefeuille projets, management visuel, mise en place d'Obeya et préparation des supports de pilotage et d'aide à la décision.",
          impact: "Une meilleure visibilité sur les priorités, une prise de décision accélérée et un pilotage renforcé des activités Engineering."
        },
        {
          sector: "Pétrochimie",
          country: "International",
          title: "Industrialiser les processus Phase-in / Phase-out",
          challenge: "Harmoniser et sécuriser des processus critiques impliquant plusieurs entités internationales tout en améliorant le pilotage et la capacité d'exécution.",
          intervention: "Analyse Lean des processus existants, co-construction des processus cibles et digitalisation de leur exécution via des modèles Asana permettant de générer automatiquement les projets, responsabilités, dépendances et jalons.",
          impact: "Processus standardisés, exécution plus robuste, pilotage renforcé et meilleure maîtrise des transitions à l'échelle internationale."
        },
        {
          sector: "Industrie",
          country: "International",
          title: "Transformer le MRP en outil de pilotage opérationnel",
          challenge: "Dans un environnement international impliquant flux intercompany, achats externes, production interne et plusieurs sites industriels, le MRP était peu utilisé et les équipes s'appuyaient largement sur des pratiques locales et des traitements manuels.",
          intervention: "Analyse des flux réels via Process Mining. Identification des causes racines impactant la qualité des résultats MRP. Harmonisation des processus entre achats, supply chain, production et usines. Fiabilisation des données de planification et des paramètres SAP. Mise en place d'indicateurs de suivi et de monitoring des usages.",
          impact: "Transformation du MRP en véritable outil de pilotage opérationnel. Harmonisation des pratiques entre entités internationales. Amélioration de la visibilité sur les besoins et les approvisionnements. Taux d'utilisation du MRP : 4% → 96%."
        },
        {
          sector: "Industrie",
          country: "International",
          title: "Fiabiliser l'ATP et piloter la performance fournisseurs",
          challenge: "Rendre les disponibilités calculées et les engagements d'approvisionnement fiables et pilotables dans un environnement international complexe.",
          intervention: "Clarification des processus, fiabilisation des confirmations fournisseurs et mise sous pilotage des mécanismes ATP au travers d'indicateurs factuels tels que le taux de lignes confirmées et l'OTIF fournisseur.",
          impact: "Une meilleure visibilité sur les risques d'approvisionnement, une fiabilité renforcée des données de planification et un pilotage durable de la performance fournisseurs."
        },
        {
          sector: "Télécommunications",
          country: "France",
          title: "Fluidifier le pilotage S&OP",
          challenge: "Améliorer la coordination entre demande, capacités et ressources.",
          intervention: "Animation du cycle S&OP, démarche DMAIC end-to-end et management visuel.",
          impact: "Meilleure visibilité et prise de décision plus rapide."
        },
        {
          sector: "Métallurgie",
          country: "France",
          title: "Structurer le pilotage d'une crise qualité",
          challenge: "Consolider une vision commune d'une situation impliquant de nombreux acteurs.",
          intervention: "Définition des KPIs, standardisation du reporting et mobilisation des parties prenantes.",
          impact: "Pilotage factuel de la crise et meilleure coordination des actions."
        },
        {
          sector: "Fabricant équipement industriel",
          country: "International",
          title: "Harmoniser les processus dans le cadre d'un déploiement ERP international",
          challenge: "Faire converger des pratiques locales vers un modèle cible partagé.",
          intervention: "Collecte des besoins, ateliers métiers, arbitrages et conception des processus cibles autour d'IFS FSM.",
          impact: "Déploiement facilité et meilleure appropriation du futur système."
        }
      ]
    },

    // Cabinet/Founder
    cabinet: {
      label: "",
      name: "Hicham EL-HADY",
      bio: "10 ans d'expérience sur des projets de transformation, d'amélioration de la performance et de déploiement ERP, en France et à l'international. Une expérience construite à l'intersection des métiers, des opérations, des processus et des systèmes, avec une spécialisation progressive sur les environnements complexes, multi-acteurs et transverses.",
      linkedin: "LinkedIn",
      contact: "Contact"
    },

    // Contact
    contact: {
      title: "Et si nous parlions de",
      titleHighlight: "vos projets",
      subtitle: "Un premier échange pour comprendre vos enjeux et identifier les leviers d'action.",
      cta1: "contact@adapel.fr",
      cta2: "Me contacter sur LinkedIn",
      testimonials: [
        { quote: "Un collaborateur fiable, brillant et autonome qui comprend facilement les différentes attentes. Force de proposition, avec une grande qualité d'exécution.", author: "Kheira H.", role: "Responsable département Engineering" },
        { quote: "Analyses pointues et pertinentes dans un contexte difficile. Il nous a aidés à lancer des projets Lean. Très professionnel jusqu'au bout.", author: "Audrey P.", role: "Responsable du service S&OP Groupe" },
        { quote: "A facilement intégré un programme complexe dans le domaine aéronautique. Réelle valeur ajoutée dans les phases de conception fonctionnelle.", author: "Frédéric A.", role: "Program Manager" },
        { quote: "Un accompagnement toujours rapide, efficace et pertinent. Au plaisir de retravailler ensemble.", author: "M. G.", role: "Operations Director" },
        { quote: "A rapidement compris les enjeux du sujet confié. S'est approprié les principes et a utilisé une application de datamining avec succès. Excellent relationnel.", author: "Marc T.", role: "Dirigeant PME" }
      ]
    },

    // Footer
    footer: {
      rights: "Tous droits réservés",
      legal: "Mentions légales"
    }
  },

  en: {
    // Navigation
    nav: {
      approche: "Approach",
      expertises: "Expertise",
      missions: "Projects",
      casClient: "Use Case",
      cta: "Let's talk"
    },

    // Hero
    hero: {
      badge: "Processes • Data • Systems • Execution",
      title1: "Structure your",
      titleHighlight1: "transformations",
      title2: "Accelerate your",
      titleHighlight2: "results",
      subtitle: "Organizations evolve, processes become more complex and systems multiply.\n\nWhen processes, systems and teams are no longer aligned, decisions slow down and execution becomes harder.\n\nADAPEL brings structure, governance and factual insights to restore visibility, secure execution and accelerate value creation.",
      cta1: "Let's discuss your challenges",
      cta2: "See examples",
      badges: [
        "Operational Transformation",
        "Process Mining & Process Intelligence",
        "ERP Transformation",
        "Data & Dashboards",
        "PMO & Delivery Excellence"
      ]
    },

    // Positioning
    positioning: {
      label: "Positioning & Approach",
      title: "Structured",
      titleHighlight: "transformations",
      subtitle: "Pragmatic, fact-based and anchored in execution.",
      positionTitle: "Positioning",
      positionText: "ADAPEL supports organizations facing cross-functional transformations, complex projects or performance challenges requiring more structure, visibility and execution capability.\n\nWe operate at the intersection of processes, organizations, data, systems and management methods.\n\nOur role is to bring the structure and factual elements needed to facilitate decisions, secure trajectories and accelerate execution.\n\nIn France and internationally, we support organizations operating in demanding, multi-stakeholder, high-stakes environments."
    },

    // Approach
    approach: {
      title: "Approach",
      subtitle: "Structured, pragmatic, fact-based and results-oriented.",
      steps: [
        "Understand the operational reality and processes as they are actually executed",
        "Objectify findings through data, facts and field teams",
        "Align the stakes and perspectives of different stakeholders",
        "Co-build target processes, organizations and transformation trajectories with teams",
        "Define clear priorities, a realistic roadmap and appropriate management methods",
        "Secure execution through clear governance and shared responsibilities",
        "Support teams over time to anchor changes durably"
      ]
    },

    // Stats
    stats: [
      { value: "10+", label: "years of experience" },
      { value: "+15", label: "transformation projects" }
    ],

    // Expertises
    expertises: {
      label: "Expertise",
      title: "Complementary",
      titleHighlight: "expertise",
      subtitle: "Processes, data, systems and governance: complementary levers serving execution.",
      cards: [
        {
          title: "Operational Transformation",
          subtitle: "Lean, Operational Excellence, continuous improvement",
          items: [
            "Flow diagnostics and optimization",
            "Lean, Kaizen and DMAIC approaches",
            "Standardization and anchoring of best practices"
          ]
        },
        {
          title: "Process Mining & Process Intelligence",
          subtitle: "SAP Signavio, real flow analysis",
          items: [
            "Process Mining and understanding of real flows",
            "Process mapping, standardization and simplification",
            "Gap identification and improvement opportunities"
          ]
        },
        {
          title: "ERP Transformation",
          subtitle: "SAP ECC, S/4HANA, IFS",
          items: [
            "ERP scoping and deployment",
            "Translating business needs into operational solutions",
            "Team support and change management"
          ]
        },
        {
          title: "Data, Performance & Executive Dashboards",
          subtitle: "Power BI, KPIs, executive reporting",
          items: [
            "Definition and implementation of operational KPIs",
            "Executive dashboards and reporting",
            "Decision support and steering insights"
          ]
        },
        {
          title: "PMO & Delivery Excellence",
          subtitle: "Governance, steering, complex transformations",
          items: [
            "Program governance and management",
            "Obeya and visual management",
            "Multi-stakeholder coordination and arbitration support"
          ]
        }
      ]
    },

    // Case Study - Use Case
    caseStudy: {
      label: "Use Case",
      title: "Transform processes",
      titleHighlight: "before transforming systems",
      subtitle: "How a business transformation and Process Mining program helped objectify priorities, improve operational performance and pave the way for S/4HANA.",
      tags: ["Business Transformation", "Process Mining", "Change Management", "Industry - International"],
      contexte: {
        title: "Context",
        text: "An international industrial group, a major player in its sector for over 70 years, faces sustained growth requiring increased structuring of its business processes. In preparation for its SAP S/4HANA migration (2028 horizon), General Management launches a strategic optimization program: PEA (Process Efficiency Accelerator)."
      },
      role: {
        title: "Our role",
        items: [
          {
            title: "Program Manager",
            description: "Co-leading the transformation program in partnership with IT program management."
          },
          {
            title: "Business Process Owner",
            description: "End-to-end process ownership for P2P, O2C, Manufacturing and Supply Chain: real flow analysis, irritant identification and prioritization, target process definition and team support in action execution and results tracking."
          }
        ]
      },
      objectives: {
        title: "Challenges & Objectives",
        items: [
          "Obtain a factual view of processes as actually executed",
          "Identify and prioritize the most relevant performance levers",
          "Generate visible gains quickly while structuring longer-term transformations",
          "Harmonize and standardize processes across the group",
          "Strengthen process ownership by business teams",
          "Pave the way for the future S/4HANA transformation"
        ]
      },
      methodology: {
        title: "Approach",
        steps: ["Understand", "Objectify", "Prioritize", "Execute", "Sustain"]
      },
      results: {
        title: "Results & Impacts",
        items: [
          { value: "138", label: "qualified insights" },
          { value: "+40", label: "key users mobilized" },
          { value: "+7", label: "countries" },
          { value: "+20", label: "initiatives launched" }
        ],
        impacts: [
          "MRP & operational steering: Data reliability, practice harmonization and generalization of usage monitoring, transforming MRP into a true operational steering tool.",
          "ATP & supplier performance: Improved supply data quality and supplier performance monitoring through factual indicators and adapted governance mechanisms."
        ]
      }
    },

    // Achievements
    achievements: {
      label: "Projects",
      title: "Examples of",
      titleHighlight: "projects",
      subtitle: "Some examples of projects completed, respecting client confidentiality.",
      challengeLabel: "Challenge",
      interventionLabel: "Intervention",
      impactLabel: "Impact",
      items: [
        {
          sector: "Construction",
          country: "France",
          title: "Support the launch of an Operational Excellence approach",
          challenge: "Build a coherent and sustainable approach across the organization.",
          intervention: "Roadmap definition, standards, training and first pilot projects.",
          impact: "Operational launch of the approach and progressive team skill-building."
        },
        {
          sector: "Nuclear",
          country: "Finland",
          title: "Structure complex program management",
          challenge: "Improve visibility and coordination between operational levels and program management.",
          intervention: "Implementation of 9 Obeyas, new management rituals and facilitator coaching.",
          impact: "Shorter decision loops and progressively autonomous teams."
        },
        {
          sector: "Agricultural Machinery",
          country: "International",
          title: "Manage a complex Engineering project portfolio",
          challenge: "Improve visibility, prioritization and management of an engineering project portfolio in a multi-project and highly interconnected environment.",
          intervention: "Governance facilitation, portfolio tracking, visual management, Obeya implementation and preparation of steering and decision-support materials.",
          impact: "Better visibility on priorities, accelerated decision-making and strengthened Engineering activities management."
        },
        {
          sector: "Petrochemical",
          country: "International",
          title: "Industrialize Phase-in / Phase-out processes",
          challenge: "Harmonize and secure critical processes involving multiple international entities while improving governance and execution capacity.",
          intervention: "Lean analysis of existing processes, co-construction of target processes and digitalization via Asana templates to automatically generate projects, responsibilities, dependencies and milestones.",
          impact: "Standardized processes, more robust execution, strengthened governance and better control of transitions at international scale."
        },
        {
          sector: "Industry",
          country: "International",
          title: "Transform MRP into an operational steering tool",
          challenge: "In an international environment involving intercompany flows, external procurement, internal production and multiple industrial sites, MRP was underutilized and teams relied heavily on local practices and manual processing.",
          intervention: "Real flow analysis via Process Mining. Root cause identification impacting MRP results quality. Process harmonization between procurement, supply chain, production and plants. Planning data and SAP parameters reliability. Usage monitoring indicators implementation.",
          impact: "Transformation of MRP into a true operational steering tool. Practice harmonization across international entities. Improved visibility on needs and supplies. MRP usage rate: 4% → 96%."
        },
        {
          sector: "Industry",
          country: "International",
          title: "Improve ATP reliability and supplier performance management",
          challenge: "Make calculated availability and supply commitments reliable and manageable in a complex international environment.",
          intervention: "Process clarification, supplier confirmation reliability and ATP mechanism monitoring through factual indicators such as confirmed line rate and supplier OTIF.",
          impact: "Better visibility on supply risks, reinforced planning data reliability and sustainable supplier performance management."
        },
        {
          sector: "Telecommunications",
          country: "France",
          title: "Streamline S&OP management",
          challenge: "Improve coordination between demand, capacity and resources.",
          intervention: "S&OP cycle facilitation, end-to-end DMAIC approach and visual management.",
          impact: "Better visibility and faster decision-making."
        },
        {
          sector: "Metallurgy",
          country: "France",
          title: "Structure quality crisis management",
          challenge: "Consolidate a shared view of a situation involving many stakeholders.",
          intervention: "KPI definition, reporting standardization and stakeholder mobilization.",
          impact: "Fact-based crisis management and better action coordination."
        },
        {
          sector: "Industrial Equipment Manufacturer",
          country: "International",
          title: "Harmonize processes for international ERP deployment",
          challenge: "Align local practices toward a shared target model.",
          intervention: "Requirements gathering, business workshops, arbitration and target process design around IFS FSM.",
          impact: "Easier deployment and better future system ownership."
        }
      ]
    },

    // Cabinet/Founder
    cabinet: {
      label: "",
      name: "Hicham EL-HADY",
      bio: "10 years of experience in transformation projects, performance improvement and ERP deployment, in France and internationally. Experience built at the intersection of business, operations, processes and systems, with progressive specialization in complex, multi-stakeholder and cross-functional environments.",
      linkedin: "LinkedIn",
      contact: "Contact"
    },

    // Contact
    contact: {
      title: "What if we talked about",
      titleHighlight: "your projects",
      subtitle: "An initial discussion to understand your challenges and identify action levers.",
      cta1: "contact@adapel.fr",
      cta2: "Contact me on LinkedIn",
      testimonials: [
        { quote: "A reliable, brilliant and autonomous collaborator who easily understands different expectations. Proactive, with great execution quality.", author: "Kheira H.", role: "Engineering Department Manager" },
        { quote: "Sharp and relevant analyses in a difficult context. He helped us launch Lean projects. Very professional throughout.", author: "Audrey P.", role: "Group S&OP Manager" },
        { quote: "Easily integrated a complex aeronautics program. Real added value in functional design phases.", author: "Frédéric A.", role: "Program Manager" },
        { quote: "Always fast, efficient and effective support. Looking forward to collaborating again.", author: "M. G.", role: "Operations Director" },
        { quote: "Quickly understood the project challenges. Mastered the principles and successfully used a datamining application. Excellent interpersonal skills.", author: "Marc T.", role: "CEO, SME" }
      ]
    },

    // Footer
    footer: {
      rights: "All rights reserved",
      legal: "Legal notice"
    }
  }
};
